import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
//Import Custom Services Here
import { DistrictSchoolService } from "../report-services/district-school.service";
import { ActionTypeService } from "../report-services/action-type.service";
import { InfractionService } from "../report-services/infraction.service";
import { SchoolGroupService } from "../report-services/school-group.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	templateUrl: "./incidentsbyinfraction.component.html",
})
export class IncidentsbyInfractionComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private schoolgroupService: SchoolGroupService,
		private infractionService: InfractionService,
		private actiontypeService: ActionTypeService,
		private districtschoolService: DistrictSchoolService,
		private dialogService: DialogService
	) {}
	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		DistrictSchoolID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
		ActionTypeID: 0,
		InfractionID: 0,
		SchoolGroupID: 0,
		ShowDetailID: "Yes",
		ImageLogo: 0,
	};
	//Insert Custom Lists Here
	DistrictSchoolList: any = [];
	ActionTypeList: any = [];
	InfractionList: any = [];
	SchoolGroupList: any = [];
	ImageLogoList: any = [];
	schoolList: any = [];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ShowDetailList = [
		//Insert Custom List Items Here
		{
			ShowDetailID: "Yes",
			ShowDetailName: "Yes",
		},
		{
			ShowDetailID: "No",
			ShowDetailName: "No",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 305;

	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadDistrictSchoolList()
		// this.loadActionTypeList()
		// this.loadInfractionList()
		// this.loadSchoolGroupList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onDistrictSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onDistrictSchoolChange(value) {
		this.report.SchoolID = value;
		this.report.DistrictSchoolID = value;
		this.loadActionTypeList();
		this.loadInfractionList();
		this.loadSchoolGroupList();
		this.loadLogolist();
	}

	private loadDistrictSchoolList() {
		this.report.DistrictSchoolID = 0;
		var result = this.districtschoolService.loadDistrictSchoolList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.DistrictSchoolList = response;

				if (this.DistrictSchoolList.length > 1) {
					// this.DistrictSchoolList.unshift({
					//     DistrictSchoolID: 0,
					//     DistrictSchoolDesc: "All District Schools"
					// })
					this.report.DistrictSchoolID = this.DistrictSchoolList[0].SchoolID;
				} else {
					this.report.DistrictSchoolID = this.DistrictSchoolList[0].SchoolID;
				}
			},
			(error) => {}
		);
	}

	private loadActionTypeList() {
		this.report.ActionTypeID = 0;
		var result = this.actiontypeService.loadActionTypeList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ActionTypeList = response;

				if (this.ActionTypeList.length > 1) {
					this.ActionTypeList.unshift({
						ActionTypeID: 0,
						ActionTypeDesc: "All Action Types",
					});
				} else {
					this.report.ActionTypeID = this.ActionTypeList[0].ActionTypeID;
				}
			},
			(error) => {}
		);
	}

	private loadInfractionList() {
		this.report.InfractionID = 0;
		var result = this.reportService.InfractionGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.InfractionList = response;

				if (this.InfractionList.length > 1) {
					this.InfractionList.unshift({
						InfractionID: 0,
						InfractionDesc: "All Infractions",
					});
				} else {
					this.report.InfractionID = this.InfractionList[0].InfractionID;
				}
			},
			(error) => {}
		);
	}

	private loadSchoolGroupList() {
		this.report.SchoolGroupID = 0;
		var result = this.schoolgroupService.loadSchoolGroupList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.SchoolGroupList = response;

				if (this.SchoolGroupList.length > 1) {
					this.SchoolGroupList.unshift({
						SchoolGroupID: 0,
						SchoolGroupDesc: "All School Groups",
					});
				} else {
					this.report.SchoolGroupID = this.SchoolGroupList[0].SchoolGroupID;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		// if (!this.report.DistrictSchoolID) {
		// 	this.errorMessage = "Select the DistrictSchool"
		// 	return;
		// }

		// if (!this.report.StartDate) {
		// 	this.errorMessage = "Select the StartDate"
		// 	return;
		// }

		// if (!this.report.EndDate) {
		// 	this.errorMessage = "Select the EndDate"
		// 	return;
		// }

		// if (!this.report.ActionTypeID) {
		// 	this.errorMessage = "Select the ActionType"
		// 	return;
		// }

		// if (!this.report.InfractionID) {
		// 	this.errorMessage = "Select the Infraction"
		// 	return;
		// }

		// if (!this.report.SchoolGroupID) {
		// 	this.errorMessage = "Select the SchoolGroup"
		// 	return;
		// }

		// if (!this.report.ShowDetailID) {
		// 	this.errorMessage = "Select the ShowDetail"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 305;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolXML
		var strParam = "<ROOT><School SchoolID='" + this.report.SchoolID + "'/></ROOT>";
		strParam += "|SchoolXML";

		//Parameter 2: StartDate
		strParam += "," + moment(this.report.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 3: EndDate
		strParam += "," + moment(this.report.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 4: ActionType
		strParam += "," + this.report.ActionTypeID + "|ActionType";

		//Parameter 5: InfractionID
		strParam += "," + this.report.InfractionID + "|InfractionID";

		//Parameter 6: ShowDetail
		strParam += "," + this.report.ShowDetailID + "|ShowDetail";

		//Parameter 7: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
